import React from 'react';
import Icon from 'src/components/Common/Icon';
import classNames from 'classnames';

/** Color options for the background of the service card. */
export const ServiceColorTypeOptions = [
  'blue',
  'blue02',
  'green',
  'green-02',
  'magenta',
  'magenta-02',
  'purple',
  'purple-02',
  'mint',
  'mint-02',
  'pink',
  'orange',
];
type ServiceColorType = (typeof ServiceColorTypeOptions)[number];

interface ServiceProps {
  /** CSS class name. */
  className?: string;
  /** Background color of the Service Card. */
  color?: ServiceColorType;
  /** Service Headline and content / description. */
  children: React.ReactNode;
  /** Name of the icon displayed at the top. */
  iconName: string;
}

// TODO: Fix headline Rendering outside of a ServiceGrid and also missing colors? SEE STORYBOOK

/** Renders a Cart with icon and text for displaying available services. */
const Service = ({ className, color, iconName, children }: ServiceProps) => (
  <div className={classNames(className, `ce-service ${color}`)}>
    <Icon name={iconName} className="text-5xl" />
    <div className="ce-service-content">{children}</div>
  </div>
);

Service.defaultProps = {
  className: null,
  color: 'blue',
};

export default Service;
